import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import logo from "../../assets/logo.svg";
import styles from "./loadingScreen.module.css";

const shineMask = { WebkitMaskImage: `url(${logo})`, maskImage: `url(${logo})` };
let scrollLocks = 0;
let previousOverflow = "";

function LoadingScreen({ open = false, message = "Loading..." }) {
    const statusRef = useRef(null);
    useEffect(() => {
        if (!open) return undefined;
        if (scrollLocks === 0) {
            previousOverflow = document.body.style.overflow;
            document.body.style.overflow = "hidden";
        }
        scrollLocks += 1;
        const previousFocus = document.activeElement;
        statusRef.current?.focus();
        return () => {
            scrollLocks -= 1;
            if (scrollLocks === 0) {
                document.body.style.overflow = previousOverflow;
                if (previousFocus?.isConnected) previousFocus.focus();
            }
        };
    }, [open]);

    if (!open) return null;
    const content = (
        <div ref={statusRef} className={styles.overlay}
            role="status" aria-live="polite" aria-busy="true" tabIndex={-1}
            onKeyDown={(event) => {
                if (event.key === "Tab" || event.key === "Escape") event.preventDefault();
                event.stopPropagation();
            }}>
            <div className={styles.logo}>
                <img src={logo} alt="" className={styles.image} />
                <span className={styles.shine} style={shineMask} aria-hidden="true" />
            </div>
            <p className={styles.message}>{message}</p>
        </div>
    );
    return createPortal(content, document.body);
}

export default LoadingScreen;
